
/** Colors used asa visual reminder of a hierarchy level */
export const hierarchyColors = [
  { light: '#CEEFEF', dark: '#19AFAF' },
  { light: '#EFC5EF', dark: '#AF19AF' },
  { light: '#EFEFC5', dark: '#AFAF19' },
  { light: '#EFCEC5', dark: '#AF1919' },
  { light: '#CEEFC5', dark: '#19AF19' },
  { light: '#CEC5EF', dark: '#1919AF' },
];

export default {
  hierarchyColors,
};
